import { useEffect, useState } from "react";
import {
  Row,
  Col,
  Divider,
  Form,
  Input,
  Button,
  Typography,
  message,
  Card,
} from "antd";
import { css } from "@emotion/css";
import { useDispatch, useSelector } from "react-redux";
import {
  NavLink as Link,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
//Action
import { sharedLoginAction } from "../store/action/shared/authAction";
import { keyframes } from "emotion";
import PasswordLockIcon from "../Icons/PasswordLockIcon";
import EmailIcon from "../Icons/EmailIcon";
import { themeAction } from "../store/action/admin/themeActions";
import { langaugeTanslatorAction } from "../store/action/admin/languageTranslatorActions";
import EyeIcon from "../Theme/CustomIcons/Icons/Security/EyeIcon";
import EyeSlashIcon from "../Theme/CustomIcons/Icons/Security/EyeSlashIcon";
import { getFcmToken } from "../shared-components/push-notification";
import {
  getAllowedAppsAction,
  getCompanyAppsAction,
} from "../store/action/admin/companyAction";
import { serviceLinks } from "./Components/dashboard";

const { Title } = Typography;
const fadeInAndFloat = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const floatingAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const cardStyle = css`
  animation: ${fadeInAndFloat} 1s forwards,
    ${floatingAnimation} 3s ease-in-out infinite;
`;

function LoginCard() {
  const router = useNavigate();
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { loading, error, sharedUserInfo } = sharedLogin;
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [searchParams] = useSearchParams();
  const redirect_back = searchParams.get("redirect_back");
  const onFinish = async (values) => {
    const email = values.email;
    const emails = email.toLowerCase();
    try {
      await dispatch(themeAction(false, true));
      // const fcmToken = await getFcmToken();
      const payload = await dispatch(
        sharedLoginAction(emails, values.password, "")
      );

      if (redirect_back) {
        const app = serviceLinks(payload).find(
          (app) => app.name === redirect_back
        );
        if (app) {
          window.location.href = app.href;
        }
      } else {
        if (payload?.defaultApp) {
          const app = serviceLinks(payload).find(
            (app) => app.name === payload?.defaultApp
          );
          if (app) {
            window.location.href = app.href;
          }
        }
      }
      const themeData = await dispatch(themeAction());
      dispatch(langaugeTanslatorAction(themeData?.language || "en"));

      dispatch(getCompanyAppsAction());
      // dispatch(getAllowedAppsAction());
      form.resetFields();
    } catch (error) {
      // message.error({ error });
      console.log(error);
    }
  };

  const changingTokenList = useSelector((state) => state.changingTokenList);
  const { tokenLoginInfo, tokenLoginError } = changingTokenList;
  const sendOtpForgetPassword = useSelector(
    (state) => state.sendOtpForgetPassword
  );
  const { sendOtpForgetPasswordInfo } = sendOtpForgetPassword;
  useEffect(() => {
    // if (tokenLoginError != null) {
    if (sharedUserInfo && sharedUserInfo?.payload) {
      dispatch(getCompanyAppsAction());
      // dispatch(getAllowedAppsAction());
      let companyId =
        sharedUserInfo?.empCompanies &&
        sharedUserInfo?.empCompanies[0]?.companyId?._id;
      if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.type === "user" &&
        sharedUserInfo?.payload?.emailVerification === true
      ) {
        if (
          sharedUserInfo?.empCompanies.length === 0 ||
          sharedUserInfo?.empCompanies.length > 1
        ) {
          router("/user/company/", { replace: true });
        } else {
          router(`/dashboard/`, { replace: true });
        }
      } else if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.type === "admin"
      ) {
        if (
          sharedUserInfo?.payload?.company &&
          sharedUserInfo?.payload?.planSub
        ) {
          router(`/dashboard/`, { replace: true });
        } else {
          if (sharedUserInfo?.payload?.company) {
            router("/admin/onboarding");
          } else {
            router("/admin/company-setup");
          }
        }
      } else if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.emailVerification === true
      ) {
        router(`/dashboard/`, {
          replace: true,
        });
      }
      //super admin work
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sharedUserInfo]);
  return (
    <>
      {/* <Row
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Col span={8}>
          <Card
            
            className={cardStyle}
            style={{
              borderRadius: "32px",
              padding: "30px",
            }}
          >
            <Row>
              <Col span={24}>
                <Title level={2}>Maximize your Efficiency</Title>
                <p className="subtitle-Body-Large-Subtle subtitle-Body-Large-padding">
                  Streamline your Time and Productivity
                </p>
                <Divider />
              </Col> */}

      {/* <Col span={24}> */}
      {sendOtpForgetPasswordInfo && (
        <>
          {/* <Col span={24} style={{ padding: "10px 0px 20px 0px" }}> */}
          <span
            style={{
              padding: "20px 0px 30px 0px",
              backgroundColor: "#f2fcf3",
              borderRadius: 8,
              border: "1px solid #10b320",
              fontSize: 14,
            }}
          >
            {sendOtpForgetPasswordInfo}
          </span>
          {/* </Col> */}
        </>
      )}
      <Form
        form={form}
        name="normal_login"
        className="login-form"
        layout="vertical"
        autoComplete="on"
        initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <Row
          gutter={[0, 0]}
          style={{ marginTop: "25px" }}
          className={css`
            .ant-input-outlined {
              height: clamp(38px, 3vw, 48px) !important;
              font-family: "Inter", sans-serif !important;
              font-size: clamp(12px, 0.8vw, 14px) !important;
            }
          `}
        >
          <Col span={24}>
            <Form.Item
              name="email"
              // label="Email*"
              rules={[
                {
                  required: true,
                  message: "Enter your Email Address",
                },
              ]}
            >
              <Input
                style={{
                  borderRadius: "20px",
                }}
                prefix={
                  <EmailIcon
                    style={{
                      margin: "0px 5px",
                      marginLeft: "7px",
                      color: "#d6d6d6",
                    }}
                  />
                }
                placeholder={"Enter your Email Address"}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="password"
              // label="Password*"
              rules={[
                {
                  required: true,
                  message: "Please input your Password",
                },
              ]}
              className={css`
                .ant-input {
                  padding-left: 0 !important;
                  background: transparent;
                }
              `}
            >
              <Input.Password
                type="password"
                placeholder="Enter your Password"
                style={{ borderRadius: "20px" }}
                prefix={
                  <PasswordLockIcon
                    style={{
                      margin: "0px 5px",
                      fontSize: "22px",
                      marginLeft: "7px",
                      color: "#d6d6d6",
                    }}
                  />
                }
                iconRender={(visible) =>
                  visible ? <EyeIcon /> : <EyeSlashIcon />
                }
              />
            </Form.Item>
          </Col>
          {error && (
            <div
              style={{
                display: "flex",
                marginBottom: 10,
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              {error && <p style={{ color: "#ff0000db" }}>{error}</p>}
              {error === "Password Incorrect" && (
                <div>
                  <p style={{ textAlign: "left" }}>
                    <Link to="/forgot-password" style={{ color: "#F37559" }}>
                      Forgot Password
                    </Link>
                  </p>
                </div>
              )}
            </div>
          )}
          <Col
            span={24}
            className={css`
              .ant-btn {
                height: 40px !important;
              }
            `}
          >
            <Form.Item noStyle>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={loading}
                style={{
                  width: "100%",
                  borderRadius: "20px",
                }}
              >
                Login
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default LoginCard;
